import * as React from 'react'
import { useCallback, useState } from 'react'
import { Alert, Button, Form, Input } from 'antd'
import { MailOutlined, UserOutlined } from '@ant-design/icons'
import { useCookies } from 'react-cookie'
import { useNavigate, Link as RouterLink } from 'react-router-dom'
import { AuthLayout } from '../../components/AuthLayout'
import { signUp } from '../../services/admin-auth-service'

interface SignUpFormValues {
  username: string
  email: string
}

const SignUp = () => {
  const navigate = useNavigate()
  const [, setCookie] = useCookies(['loginToken'])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const submit = useCallback(async (values: SignUpFormValues) => {
    setError('')
    setLoading(true)
    try {
      const { accessToken } = await signUp({ ...values, role: 'ROLE_ADMIN' })
      setCookie('loginToken', accessToken, { path: '/' })
      navigate('/')
    } catch (e: any) {
      setError(e.message)
    } finally {
      setLoading(false)
    }
  }, [setCookie, navigate])

  return (
    <AuthLayout
      headline='Create an admin account'
      subtext='Admin accounts can create organizations and doctors once signed in. Organizations and doctors are added from inside the portal, not here.'
      footer={
        <span>
          Already have an account? <RouterLink to='/login'>Sign in</RouterLink>
        </span>
      }>
      {error && <Alert style={{ marginBottom: 16 }} showIcon message={error} type='error' />}

      <Form name='sign-up-form' layout='vertical' onFinish={submit} autoComplete='off'>
        <Form.Item name='username' label='Username' rules={[{ required: true, message: 'Enter a username.' }]}>
          <Input size='large' prefix={<UserOutlined style={{ color: '#9AA3B8' }} />} placeholder='Username' />
        </Form.Item>

        <Form.Item name='email' label='Email' rules={[{ required: true, type: 'email', message: 'Enter a valid email.' }]}>
          <Input size='large' prefix={<MailOutlined style={{ color: '#9AA3B8' }} />} placeholder='you@organization.com' />
        </Form.Item>

        <Form.Item style={{ marginTop: 8 }}>
          <Button block size='large' type='primary' htmlType='submit' loading={loading}>
            Create Account
          </Button>
        </Form.Item>
      </Form>
    </AuthLayout>
  )
}

export default SignUp
